"use strict";
/*
 * @license
 * Copyright (c) 2019 Cristian Abrante. All rights reserved.
 * Licensed under the MIT License. See LICENSE in the project root for license information.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Population_1 = require("../../population/Population");

var BaseReplacement =
/** @class */
function () {
  function BaseReplacement() {}

  BaseReplacement.prototype.replace = function (oldPopulation, newPopulation, params) {
    var returnPopulation = new Population_1.default();
    oldPopulation.getPopulationItems().concat(newPopulation.getPopulationItems()).sort(this.sortMethod).slice(0, params.selectionCount).forEach(function (item) {
      returnPopulation.pushIndividual(item.individual, item.fitness, item.age + 1);
    });
    return returnPopulation;
  };

  BaseReplacement.prototype.pushIndividual = function (population, item) {
    population.pushIndividual(item.individual, item.fitness, item.age + 1);
  };

  return BaseReplacement;
}();

exports.default = BaseReplacement;